<template>
  <div class="row">
    <div class="col-md-2">
      <vx-card subtitle="Información de la empresa">
        <table>
          <tr>
            <td class="p-2 font-bold">Folio consulta</td>
            <td class="p-2">{{result.folioConsulta}}</td>
          </tr>
          <tr>
            <td class="p-2 font-bold">Folio otorgante</td>
            <td class="p-2">{{result.folioOtorgante}}</td>
          </tr>
          <tr>
            <td class="p-2 font-bold">Clave retorno</td>
            <td class="p-2">{{result.folioOtorgante}}</td>
          </tr>
          <tr>
            <td class="p-2 font-bold">RFC</td>
            <td class="p-2">{{result.persona.RFC}}</td>
          </tr>
          <tr>
            <td class="p-2 font-bold">Nombre</td>
            <td class="p-2">{{result.persona.nombre}}</td>
          </tr>
          <tr>
            <td class="p-2 font-bold">Domicilio</td>
            <td class="p-2">
              {{result.persona.domicilio.direccion}},
              {{result.persona.domicilio.ciudad}},
              {{result.persona.domicilio.estado}},
              {{result.persona.domicilio.pais}} C.P. {{result.persona.domicilio.CP}}
            </td>
          </tr>
        </table>
      </vx-card>
    </div>
    <div class="col-md-10">
      <div class="row">
        <vx-card subtitle="Claves Banxico">
          <vs-table :data="[{}]">
            <template slot="thead">
              <vs-th>Clave banxico 1</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr>
                <vs-td>{{result.clavesBanxico.claveBanxico1}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2">
        <vx-card subtitle="Créditos financieros">
          <vs-table :data="result.credito.cuentasFinancieras" title="Créditos / Cuentas financieras">
            <template slot="thead">
              <vs-th>RFC</vs-th>
              <vs-th>CURP</vs-th>
              <vs-th>Contrato</vs-th>
              <vs-th>Otorgante</vs-th>
              <vs-th>Saldo inicial</vs-th>
              <vs-th>Saldo total</vs-th>
              <vs-th>Fecha apertura</vs-th>
              <vs-th>Plazo</vs-th>
              <vs-th>Claves de observación</vs-th>
              <vs-th>Tipo de crédito</vs-th>
              <vs-th>Fecha de cierre</vs-th>
              <vs-th>Atraso mayor</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="financeCredit in data">
                <vs-td>{{financeCredit.RFC}}</vs-td>
                <vs-td>{{financeCredit.CURP}}</vs-td>
                <vs-td>{{financeCredit.contrato}}</vs-td>
                <vs-td>{{financeCredit.nombreOtorgante}}</vs-td>
                <vs-td>{{financeCredit.saldoInicial}}</vs-td>
                <vs-td>{{financeCredit.saldoTotal}}</vs-td>
                <vs-td>{{financeCredit.fechaApertura}}</vs-td>
                <vs-td>{{financeCredit.plazo}}</vs-td>
                <vs-td>{{financeCredit.clavesObservacion}}</vs-td>
                <vs-td>{{financeCredit.tipoCredito}}</vs-td>
                <vs-td>{{financeCredit.fechaCierre}}</vs-td>
                <vs-td>{{financeCredit.atrasoMayor}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2">
        <vx-card subtitle="Créditos comerciales">
          <vs-table :data="result.credito.cuentasComerciales" title="Créditos / Cuentas comerciales">
            <template slot="thead">
              <vs-th>RFC</vs-th>
              <vs-th>Otorgante</vs-th>
              <vs-th>Saldo total</vs-th>
              <vs-th>Última actualización</vs-th>
              <vs-th>Atraso mayor</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="commercialCredit in data">
                <vs-td>{{commercialCredit.RFC}}</vs-td>
                <vs-td>{{commercialCredit.nombreOtorgante}}</vs-td>
                <vs-td>{{commercialCredit.saldoTotal}}</vs-td>
                <vs-td>{{commercialCredit.actualizacion}}</vs-td>
                <vs-td>{{commercialCredit.atrasoMayor}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2" v-if="result.clavePrevenciones">
        <vx-card subtitle="Claves prevención">
          <vs-table :data="result.clavePrevenciones">
            <template slot="thead">
              <vs-th>Nombre</vs-th>
              <vs-th>Fecha de reporte</vs-th>
              <vs-th>Número de contrato</vs-th>
              <vs-th>Clave de prevención</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="a in data">
                <vs-td>{{a.nombreOtorgante}}</vs-td>
                <vs-td>{{a.fechaReporte}}</vs-td>
                <vs-td>{{a.numeroContrato}}</vs-td>
                <vs-td>{{a.clavePrevencion}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2">
        <vx-card subtitle="Historial de consultas">
          <vs-table :data="[{}]" title="Consultas">
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th>Últimos 3 meses</vs-th>
              <vs-th>Últimos 12 meses</vs-th>
              <vs-th>Últimos 24 meses</vs-th>
              <vs-th>Más 24 meses</vs-th>
            </template>
            <template>
              <vs-tr>
                <vs-td class="font-bold">Consultas financieras</vs-td>
                <vs-td>{{result.consultasInstitucionales.financieras.ultimos3meses}}</vs-td>
                <vs-td>{{result.consultasInstitucionales.financieras.ultimos12meses}}</vs-td>
                <vs-td>{{result.consultasInstitucionales.financieras.ultimos24meses}}</vs-td>
                <vs-td>{{result.consultasInstitucionales.financieras.mas24meses}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="font-bold">Consultas comerciales</vs-td>
                <vs-td>{{result.consultasInstitucionales.comerciales.ultimos3meses}}</vs-td>
                <vs-td>{{result.consultasInstitucionales.comerciales.ultimos12meses}}</vs-td>
                <vs-td>{{result.consultasInstitucionales.comerciales.ultimos24meses}}</vs-td>
                <vs-td>{{result.consultasInstitucionales.comerciales.mas24meses}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2">
        <vx-card subtitle="Accionistas">
          <vs-table :data="result.accionistas" title="Accionistas">
            <template slot="thead">
              <vs-th>Nombre</vs-th>
              <vs-th>RFC</vs-th>
              <vs-th>CURP</vs-th>
              <vs-th>Domicilio</vs-th>
              <vs-th>Teléfono</vs-th>
              <vs-th>Porcentaje</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="issuer in data">
                <vs-td>{{issuer.nombre}} {{issuer.segundoNombre}} {{issuer.apellidoPaterno}} {{issuer.apellidoMaterno}}</vs-td>
                <vs-td>{{issuer.RFC}}</vs-td>
                <vs-td>{{issuer.CURP}}</vs-td>
                <vs-td>
                  {{issuer.domicilio.direccion}},
                  {{issuer.domicilio.coloniaPoblacion}},
                  {{issuer.domicilio.delegacionMunicipio}}, <br>
                  {{issuer.domicilio.ciudad}},
                  {{issuer.domicilio.estado}},
                  C.P. {{issuer.domicilio.CP}},
                  {{issuer.domicilio.pais}}
                </vs-td>
                <vs-td>{{issuer.CURP}}</vs-td>
                <vs-td>{{issuer.porcentaje}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2">
        <vx-card subtitle="Avales">
          <vs-table :data="result.avales" title="Accionistas">
            <template slot="thead">
              <vs-th>Nombre</vs-th>
              <vs-th>RFC</vs-th>
              <vs-th>CURP</vs-th>
              <vs-th>Domicilio</vs-th>
              <vs-th>Teléfono</vs-th>
              <vs-th>Cantidad avalada</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="issuer in data">
                <vs-td>{{issuer.nombre}} {{issuer.segundoNombre}} {{issuer.apellidoPaterno}} {{issuer.apellidoMaterno}}</vs-td>
                <vs-td>{{issuer.RFC}}</vs-td>
                <vs-td>{{issuer.CURP}}</vs-td>
                <vs-td>
                  {{issuer.domicilio.direccion}},
                  {{issuer.domicilio.coloniaPoblacion}},
                  {{issuer.domicilio.delegacionMunicipio}}, <br>
                  {{issuer.domicilio.ciudad}},
                  {{issuer.domicilio.estado}},
                  C.P. {{issuer.domicilio.CP}},
                  {{issuer.domicilio.pais}}
                </vs-td>
                <vs-td>{{issuer.CURP}}</vs-td>
                <vs-td>{{issuer.cantidad}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2">
        <vx-card subtitle="Calificación de cartera por otras instituciones crediticias">
          <vs-table :data="result.calificacionCartera" title="Calificación cartera">
            <template slot="thead">
              <vs-th>Nombre Otorgante</vs-th>
              <vs-th>Calificación</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="score in data">
                <vs-td>{{score.nombreOtorgante}}</vs-td>
                <vs-td>{{score.calificacion}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="row mt-2" v-if="result.declarativas">
        <vx-card subtitle="Declarativas del solicitante">
          <vs-table :data="result.declarativas">
            <template slot="thead">
              <vs-th>Argumento</vs-th>
              <vs-th>Fecha</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="d in data">
                <vs-td>{{d.declarativa}}</vs-td>
                <vs-td>{{d.fechaDeclarativa}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessProfileCdcReportResult",
  props: {
    result: {
      type: Object|null,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
